import axios from "axios";

export const state = {
    permissions: [],
};

export const getters = {
    permissions: state => state.permissions,
};

export const mutations = {
    setPermissions(permissions, newValue) {
        state.permissions = newValue
    },
};

export const actions = {
    fetchPermissions({ commit }) {
        axios.get('/permissions').then(res => {
            commit('setPermissions', res.data.permissions)
        })
    },
};
